// extracted by mini-css-extract-plugin
module.exports = {"classes":"\"../../../themes/theme.module.css\"","moss400":"#06AC0C","lake500":"#00829B"};